
import { useEffect, useState, useContext } from "react";
import UserContext from '../shared/UserContext.js';

export default function InfoBanner() {
    const [msgReport, setMsgReport] = useState("");
    const { session, setSession } = useContext(UserContext);
    const enigme = session.currentPage;
    const render = (session.step > 1)?true:false;
    const renderButton = (session.currentPage > 0)?true:false;
    let msg = "";

    useEffect(() => {
        if(msgReport.length > 0) setMsgReport("");  //RESET DU MESSAGE DE MAIL QUAND CHANGEMENT DE PAGE
    }, [session.currentPage]);

    if (!render) return;

    function getInfoBanner() {
        if (typeof session.route[0].infoBanner === 'undefined') {
            return ('');
        } else {
            return (session.route[0].infoBanner);
        }
    }
    
    const renderTopPageLogo = () => {

        if (typeof session.route[0].infoBanner === 'undefined') {
            return ('');
        } else {
            return (

                    <div className="infobanner">
                        <center>{session.route[0].infoBanner}</center>
                    </div>
            );
        };
    };

    return renderTopPageLogo();
}